module.exports = "/shifts/components/taskTemplatesSidebarComponent-9640a9.html";